module.exports = __webpack_public_path__ + "static/media/U.6249a48f.svg";